import { render, staticRenderFns } from "./ClassRoomInfo.vue?vue&type=template&id=6c55a40e&scoped=true&"
import script from "./ClassRoomInfo.vue?vue&type=script&lang=js&"
export * from "./ClassRoomInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55a40e",
  null
  
)

export default component.exports